export { default } from './DenunciasFraudes25Banner';
